import { gql } from "apollo-boost";

const SYNC_TEMP_VENDOR_DMS_PRODUCT = gql`
  mutation syncTempVendorDmsProduct($input: BulkAction!) {
    syncTempVendorDmsProduct(input: $input) {
      data
      status
      error
    }
  }
`;

export default SYNC_TEMP_VENDOR_DMS_PRODUCT;
